<template>
  <app-layout>
    <div class="max-w-full mt-40">
      <create-retro-form @created="boardCreated"></create-retro-form>
    </div>
  </app-layout>


</template>

<script>

import AppLayout from "@/Layouts/AppLayout";
import CreateRetroForm from "@/Pages/Retrospective/CreateRetroForm";
import {CheckIcon, PlusIcon, XIcon, ThumbUpIcon, ChatIcon,PencilIcon} from "@heroicons/vue/outline";

export default {
  props: [],
  setup() {
    const boardCreated = (id) => {
      createRetroModal.value = false;
      Inertia.visit(
          route("retrospective.accessRoom", {
            id: id,
          })
      );
    }
    return {
      boardCreated
    }
  },
  data() {
    return {
      isUserLoggedIn: false,
    };
  },
  mounted() {
  },
  methods: {
    startGame() {

    }
  },

  components: {
    CreateRetroForm,
    AppLayout,
  },
};
</script>
